export default "__VITE_ASSET__DokQofw2__"